(() => {
  if (customElements.get('complete-the-look-products')) return;

  class CompleteTheLookProducts extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('.ctl__panel')) return;

      const url = this.getAttribute('data-url');
      if (!url) return;

      this.fetchProducts(url);
    }

    async fetchProducts(url) {
      try {
        const response = await fetch(url);
        const text = await response.text();
        const html = new DOMParser().parseFromString(text, 'text/html');
        const source = html.querySelector('.ctl__panels-source');

        if (!source || !source.innerHTML.trim()) return;

        this.querySelector('.ctl__panels-source').innerHTML = source.innerHTML;
        this.parentElement.removeAttribute('hidden');

        this.initVariantPickers();
        this.initNavigation();

        const cartDrawer = document.querySelector('quick-cart-drawer');
        if (cartDrawer) cartDrawer.init();
      } catch (e) {
        console.error('Complete the Look: failed to load products', e);
      }
    }

    initVariantPickers() {
      this.querySelectorAll('.ctl__variants').forEach((picker) => {
        picker.addEventListener('click', (e) => {
          const btn = e.target.closest('.ctl__variant-btn');
          if (!btn || btn.disabled) return;

          picker.querySelectorAll('.ctl__variant-btn').forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');

          const panel = btn.closest('.ctl__panel');
          const input = panel.querySelector('.product-variant-id');
          if (input) input.value = btn.dataset.variantId;
        });
      });
    }

    initNavigation() {
      this.panels = [...this.querySelectorAll('.ctl__panel')];
      if (this.panels.length <= 1) return;

      this.currentIndex = 0;

      const nav = document.createElement('div');
      nav.className = 'ctl__nav';
      nav.innerHTML = `
        <button type="button" class="ctl__nav-btn ctl__nav-btn--prev" aria-label="Previous" disabled>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>
        </button>
        <button type="button" class="ctl__nav-btn ctl__nav-btn--next" aria-label="Next">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg>
        </button>
      `;

      this.querySelector('.ctl__panels-source').prepend(nav);

      nav.querySelector('.ctl__nav-btn--prev').addEventListener('click', () => this.goTo(this.currentIndex - 1));
      nav.querySelector('.ctl__nav-btn--next').addEventListener('click', () => this.goTo(this.currentIndex + 1));
    }

    goTo(index) {
      if (index < 0 || index >= this.panels.length) return;

      this.panels[this.currentIndex].classList.add('hidden');
      this.currentIndex = index;
      this.panels[this.currentIndex].classList.remove('hidden');

      const prev = this.querySelector('.ctl__nav-btn--prev');
      const next = this.querySelector('.ctl__nav-btn--next');
      if (prev) prev.disabled = this.currentIndex === 0;
      if (next) next.disabled = this.currentIndex === this.panels.length - 1;
    }
  }

  customElements.define('complete-the-look-products', CompleteTheLookProducts);
})();
